import { Drawer } from 'antd'
import React, { memo } from 'react'
import { Outlet } from 'react-router-dom'

export default memo(function OrganizationGroup() {
  return (
    (<Drawer placement={'right'} closable={false} maskClosable={false} open={true} width={900}>
      <Outlet />
    </Drawer>)
  );
})
